import { render, staticRenderFns } from "./OrganizationSettingsLayout.vue?vue&type=template&id=0bcaaf46&"
import script from "./OrganizationSettingsLayout.vue?vue&type=script&lang=js&"
export * from "./OrganizationSettingsLayout.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSettingsLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports